var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{attrs:{"border-variant":"white"}},[_c('b-card-title',[_vm._v("ACCOUNT / DATA DELETION")])],1),_c('b-card',{staticClass:"mb-2",attrs:{"align":"left"}},[_c('b-card-text',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }